"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_RESPONSIBILITIES_BY_ROLE = exports.JD_TEMPLATES = void 0;
exports.JD_TEMPLATES = {
    TECH_STARTUP: {
        name: 'Tech Startup',
        tone: 'casual',
        sections: ['about_company', 'about_role', 'responsibilities', 'requirements', 'benefits', 'culture'],
        benefits: [
            'Competitive salary and equity',
            'Flexible working hours',
            'Remote-friendly environment',
            'Health insurance',
            'Learning and development budget',
            'Team events and offsites'
        ]
    },
    CORPORATE: {
        name: 'Corporate',
        tone: 'formal',
        sections: ['about_company', 'about_role', 'responsibilities', 'requirements', 'qualifications', 'benefits'],
        benefits: [
            'Competitive compensation package',
            'Comprehensive health and dental insurance',
            'Retirement savings plan',
            'Professional development opportunities',
            'Work-life balance initiatives'
        ]
    },
    AGENCY: {
        name: 'Agency',
        tone: 'professional',
        sections: ['about_company', 'about_role', 'client_work', 'responsibilities', 'requirements', 'benefits'],
        benefits: [
            'Diverse project portfolio',
            'Fast-paced environment',
            'Career growth opportunities',
            'Creative freedom',
            'Competitive salary'
        ]
    }
};
exports.DEFAULT_RESPONSIBILITIES_BY_ROLE = {
    'Software Engineer': [
        'Design, develop, and maintain software applications',
        'Write clean, testable, and efficient code',
        'Collaborate with cross-functional teams',
        'Participate in code reviews',
        'Troubleshoot and debug applications'
    ],
    'Product Manager': [
        'Define product vision and strategy',
        'Gather and prioritize product requirements',
        'Work closely with engineering and design teams',
        'Analyze market trends and competition',
        'Define and track product metrics'
    ],
    'Designer': [
        'Create user-centered designs',
        'Develop wireframes and prototypes',
        'Conduct user research',
        'Collaborate with product and engineering teams',
        'Maintain design systems and guidelines'
    ]
};
//# sourceMappingURL=job-templates.js.map